<header class="" ng-class="$ctrl.headerClasses">
    <div c-loader></div>
    <div class="main-header c-main-bgcolor c-main-color">
        <section class="left-aligned">
            <div c-service-menu></div>
            <c-svg image="$ctrl.logoImage" classes="$ctrl.logoClassesMobile"></c-svg>
            <c-top-menu show="{ fixed: $ctrl.showFixed() }" class="new-menu"></c-top-menu>
        </section>
        <section class="right-aligned">
            <c-top-menu show="{ extras: true, menus: true }" class="main-menu"></c-top-menu>
            <c-svg image="$ctrl.logoImage" classes="$ctrl.logoClasses"></c-svg>
            <div c-global-search class="item"></div>
            <c-history-navigator class="item"></c-history-navigator>            
            <div c-documents-checked-out class="item"></div>
            <div c-document-assistant class="item" ng-click="$ctrl.showAssistant()"></div>
            <c-status-feedback class="item"></c-status-feedback>
        </section>
    </div>
    <div class="mobile-header" ng-hide="$ctrl.hideMobileMenu()">
        <div class="sidebar-button" id="treebutton" ng-click="$ctrl.showNavigation()"></div>
        <c-mobile-menu></c-mobile-menu>
        <div c-global-search class="search-button"></div>
        <div class="filter-button" ng-click="$ctrl.filterToggle()" ng-class="{ 'active': $ctrl.showFilter }"><i class="fa fa-bolt" ng-class="{ isfiltering: $ctrl.isFiltering }"></i>&nbsp;Filter</div>
        <c-status-feedback class="feedback"></c-status-feedback>
    </div>
</header>